import React from "react";
import styled from "styled-components";

const OPTIONS = [
  { key: "ALL", label: "All Model" },
  { key: "SUPPORTED", label: "Supported Model" },
  { key: "UNSUPPORTED", label: "Unsupported Model" },
];

const Wrap = styled.div`
  display: flex;
  gap: 4px;
`;

const FilterButton = styled.button`
  &&& {
    min-width: 56px;
    height: 28px;
    padding: 0 16px;
    font-size: 12px;
    border: 1px solid #b8cbe0;
    background-color: #e5f3ff;
    color: #002c5f;
    cursor: pointer;
    border-radius: 3px;
  }
  &&&.active {
    background-color: #002c5f;
    border-color: #002c5f;
    color: #fff;
  }
`;

const SupportFilterButtons = ({ selected, onSelect }) => {
  return (
    <Wrap>
      {OPTIONS.map((option) => (
        <FilterButton
          key={option.key}
          type="button"
          className={selected === option.key ? "active" : ""}
          onClick={() => onSelect(option.key)}
        >
          {option.label}
        </FilterButton>
      ))}
    </Wrap>
  );
};

export default SupportFilterButtons;
